import { useLoaMedicalTestContext } from "../../../Contexts/LoaMedicalTestContext";
import React, { useEffect, useRef, useState } from "react";
import { truncateStr } from "../../../utilities/helper";
import CloseIcon from "@mui/icons-material/Close";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { Modal } from "@mui/material";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function FilePreview() {
  const { viewModalShown, base64File, formData, setViewModalShown } =
    useLoaMedicalTestContext();

  const [containerWidth, setContainerWidth] = useState(0);
  const [numPages, setNumPages] = useState(0);
  const [isPdf, setIsPdf] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const updateContainerWidth = () => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        setContainerWidth(width - 30);
      }
    };

    updateContainerWidth();
    window.addEventListener("resize", updateContainerWidth);
    return () => {
      window.removeEventListener("resize", updateContainerWidth);
    };
  }, []);

  useEffect(() => {
    if (base64File?.includes("data:application/pdf;base64")) {
      setIsPdf(true);
    }
  }, [base64File]);

  const handleClose = () => {
    setViewModalShown(false);
  };

  let content = null;
  if (isPdf) {
    content = (
      <Document
        file={base64File}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={containerWidth}
          />
        ))}
      </Document>
    );
  } else {
    content = <img src={base64File} width="100%" alt="file" />;
  }

  return (
    <Modal
      open={viewModalShown}
      onClose={handleClose}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="w-full sm:w-[500px] h-full sm:h-fit bg-white m-auto sm:rounded-2xl overflow-hidden">
        <div className="border-bottom-1 flex items-center justify-between">
          <div className="w-12 h-12" />
          <p>{truncateStr(formData.attachment?.name)}</p>
          <button className="w-12 h-12" onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>
        <div
          className="flex flex-col h-[calc(100vh-48px)] sm:h-fit sm:max-h-[calc(100vh-70px)] overflow-auto p-3 bg-[#c8c9c9]"
          ref={containerRef}
        >
          {content}
        </div>
      </div>
    </Modal>
  );
}

export default FilePreview;
